const baseURL = process.env.VUE_APP_BASEURL;

class CacheInterceptor {
  constructor(list) {
    this.whiteList = [...list];
    this._cache = {};
  }
  check(config) {
    let url = config.baseURL + config.url;
    if (this._cache[url]) {
      return this._cache[url];
    } else {
      return false;
    }
  }
  capture(response) {
    if (this.whiteList.indexOf(response.config.url) !== -1) {
      this._cache[response.config.url] = response.data.data;
    }
  }
}
const whiteList = [
  "/common/func/get-tree",
  "/common/industry/get-tree",
  "/common/area/get-tree",
  "/common/property/getStaticValues",
  "/common/permission-menu/get-tree",
  "/resume/soft-skill/get-tree"
].map(item => baseURL + item);

export default new CacheInterceptor(whiteList);
